module.exports = __webpack_public_path__ + "static/media/imgop_background.058913aa.jpg";